import I18n from 'app/i18n';

export type FaqCategoryKey = string;

export interface FaqCategoryOption {
    key: FaqCategoryKey;
    label: string;
}

export interface FaqItemCategorySource {
    category?: string;
    sequence?: number;
}

export const buildCategoryOptionsFromFaqItems = (
    items: readonly FaqItemCategorySource[]
): FaqCategoryOption[] => {
    const seen = new Set<string>();
    const orderedKeys: string[] = [];
    const sortedItems = [...items].sort((a, b) => (a.sequence ?? 0) - (b.sequence ?? 0));

    sortedItems.forEach(item => {
        if (!item.category || seen.has(item.category)) {
            return;
        }

        seen.add(item.category);
        orderedKeys.push(item.category);
    });

    return orderedKeys.map(key => ({
        key,
        label: I18n.t(`faq.categories.${key}`)
    }));
};

export const buildKnownCategoryKeys = (options: readonly FaqCategoryOption[]): Set<FaqCategoryKey> => new Set(options.map(option => option.key));

export const isFaqCategoryKey = (
    value: string,
    knownKeys: ReadonlySet<FaqCategoryKey>
): value is FaqCategoryKey => knownKeys.has(value);
